<template>
  <div id="WriterList">
    
    <v-list class=" mt-4 pb-0 pt-0 white tileCard"  two-line>


        <v-list-item  class="grey lighten-5 " @click="moreInfo(writer)">
    
    

            <v-list-item-content  >
                <v-list-item-title class=" light-blue--text text--darken-3 subheading font-weight-medium" >{{writer.writer_name}} {{writer.writer_title}}</v-list-item-title>
              <v-list-item-subtitle class="mt-1 "> 
                Status: 
                <span :class="{'red--text' : writer.evaluation_status === 'Not Yet Requested', 'amber--text text--darken-3' : writer.evaluation_status === 'Agreed to write evaluation', 'blue--text text--lighten-1' : writer.evaluation_status === 'Submitted to CASPA', 'green--text' : writer.evaluation_status === 'Received'}">
                  {{writer.evaluation_status}}
                </span>

              </v-list-item-subtitle>
          
        
            </v-list-item-content  >
        
          
            <v-list-item-action class="mb-3">
          
            <v-btn class="mt-2" icon rounded :ripple="false" >
              <v-icon color="grey">mdi-chevron-right</v-icon>
              </v-btn>

        

            </v-list-item-action>
    
    
        </v-list-item >
      
      
    
    </v-list>    


     
  </div>

</template>

<script>
  export default {
    props: ['writer'],
     data() {
      return {
        modal: false,
        alert: false,
        InfoPaShadowingDialog: false,
      }
    },
    methods: {
      moreInfo (writer) {
        this.$router.push('/dashboard/evaluations/evaluationwriterinfo/' + writer.id)
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
      // totalShadowingHours() {
      //     return this.paShadow.logged_hours.reduce((sum, loggedHours)=> {
      //        return sum + parseInt(loggedHours.shadowing_hours)
      //   }, 0)
      
    },
  }
</script>

<style scoped>
.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Evaluations/WriterList.vue